import { render, staticRenderFns } from "./Staging-Pending.vue?vue&type=template&id=5146dd12&scoped=true&"
import script from "./Staging-Pending.vue?vue&type=script&lang=js&"
export * from "./Staging-Pending.vue?vue&type=script&lang=js&"
import style0 from "./Staging-Pending.vue?vue&type=style&index=0&id=5146dd12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5146dd12",
  null
  
)

export default component.exports